export default __webpack_public_path__ + "static/media/AD.db819cda.svg";